// extracted by mini-css-extract-plugin
export var container = "styles-module--container--1zKVS";
export var content = "styles-module--content--Myk4E";